import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import { css } from "styled-components/macro"; //eslint-disable-line
import Header from "components/headers/light.js";
import Footer from "components/footers/MiniCenteredFooter";
import ContactUsForm from "components/forms/TwoColContactUsWithIllustrationFullForm.js";
import ContactDetails from "components/cards/ThreeColContactDetails.js";

const Address = tw.span`leading-relaxed`;
const AddressLine = tw.span`block`;
const Email = tw.span`text-sm mt-6 block text-gray-500`;
const Phone = tw.span`text-sm mt-0 block text-gray-500`;

export default () => {
  return (
    <AnimationRevealPage>
      {/* <Header /> */}
      {/* <ContactUsForm /> */}
      <ContactDetails
        cards={[
          {
            title: "Dhaka",
            description: (
              <>
                <Address>
                  <AddressLine>5th-10th Floor, Autograph Tower</AddressLine>
                  <AddressLine>67 & 68 Kemal Ataturk Avenue</AddressLine>
                  <AddressLine>Banani, Dhaka-1213</AddressLine>
                </Address>
                <Phone>+880 1711409742</Phone>
                <Phone>+880 1730093875</Phone>
              </>
            )
          }
        ]}
      />
      <Footer />
    </AnimationRevealPage>
  );
};
